<template>
    <v-card class="mx-auto" id="contain">
        <v-overlay :model-value="overlay" class="align-center justify-center">
            <v-progress-circular
                color="blue-lighten-3"
                indeterminate
                :size="120"
            >
                <v-img
                    src="/images/d3_connect.png"
                    v-if="overlay"
                    :size="10"
                    class="loading-spinner"
                    :style="{
                        marginLeft: '9px',
                    }"
                    indeterminate
                ></v-img>
            </v-progress-circular>
        </v-overlay>
        <v-window v-model="step" class="overflow-y-auto">
            <v-window-item :value="1">
                <v-toolbar title="Material Used">
                    <v-spacer></v-spacer>
                    <v-col cols="4">
                        <v-text-field
                            v-model="searchValue"
                            append-inner-icon="mid:mdi-magnify"
                            label="Search"
                            variant="solo"
                            density="compact"
                            hide-details
                            clearable
                            @click:clear="onClearClicked"
                        ></v-text-field>
                    </v-col>
                </v-toolbar>
                <v-container class="bg-surface-variant">
                    <v-row no-gutters>
                        <v-col order="1" v-if="!showingAddByPart && material">
                            <v-sheet class="pa-2 ma-2">
                                <span class="container"
                                >Job Number:
                                    {{ material.JobNum || "-" }}</span
                                >
                            </v-sheet>
                        </v-col>
                        <v-col order="6" v-if="!showingAddByPart && material">
                            <v-sheet class="pa-2 ma-2">
                                <span class="container"
                                >Asm: {{ material.AsmSeq || "-" }}</span
                                >
                            </v-sheet>
                        </v-col>
                        <v-col order="6" v-if="showingAddByPart && !material">
                            <v-sheet class="pa-2 ma-2">
                                <span class="container"
                                >Part: {{ partNumber }}</span
                                >
                            </v-sheet>
                        </v-col>
                        <v-col order="12" v-if="!showingAddByPart && material">
                            <v-sheet class="pa-2 ma-2">
                                <span class="container"
                                >OPE Seq: {{ material.OprSeq || "-" }}</span
                                >
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-container>

                <!-- </v-card-text> -->
                <div class="grid">
                    <div class="grid-header">
                        <strong></strong>
                    </div>
                    <div class="grid-header">
                        <strong> Job </strong>
                    </div>
                    <div class="grid-header">
                        <strong> Part # </strong>
                    </div>
                    <div class="grid-header">
                        <strong> Asm </strong>
                    </div>
                    <div class="grid-header">
                        <strong> Mtl </strong>
                    </div>
                    <div class="grid-header">
                        <strong> Required Qty </strong>
                    </div>
                    <div class="grid-header">
                        <strong> Prev Issued </strong>
                    </div>
                    <div class="grid-header">
                        <v-btn variant="text" append-icon="mdi:mdi-help">
                            <strong> Available </strong>
                            <v-tooltip activator="parent" location="bottom"
                            >Pieces created from previous operation
                            </v-tooltip>
                        </v-btn>
                    </div>
                    <div class="grid-header">
                        <v-btn variant="text" append-icon="mdi:mdi-help">
                            <strong> On Hand </strong>
                            <v-tooltip activator="parent" location="bottom"
                            >Pieces in warehouse(may include available
                                pieces)
                            </v-tooltip>
                        </v-btn>
                    </div>
                    <div class="grid-header">
                        <strong> Request </strong>
                    </div>
                    <div class="grid-header">
                        <strong v-if="!showingAddByPart && material">
                            View Material
                        </strong>
                    </div>
                    <template
                        v-for="(item, index) in partRequest"
                        :key="item.id"
                    >
                        <div class="grid-item" :class="getRowClassName(item)">
                            <v-checkbox
                                v-model="checkBox[index]"
                                @input="toggleSelectedMaterial(item, index)"
                            ></v-checkbox>
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.JobNum }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.PartNum }} &nbsp;
                            <v-icon
                                :icon="
                                    item.Staged
                                        ? 'fa-solid fa-circle-arrow-right'
                                        : 'fa-solid fa-circle-check'
                                "
                                size="x-small"
                                :color="item.Staged ? 'warning' : 'success'"
                            >
                            </v-icon>
                            <v-icon
                                icon="mdi:mdi-file-document"
                                size="large"
                                color="orange orange-darken-4"
                            >
                            </v-icon>
                            <v-tooltip activator="parent" location="end"
                            >{{ getPartClass(item) }}
                            </v-tooltip>
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.AssemblySeq }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.MtlSeq }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.RequiredQty }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.IssuedQty }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            {{ item.Available }}
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            <span style="margin-right: 10px">{{ parseInt(item.Qty) }}</span>
                            <v-icon
                                v-if="item.IsCNCOpComplete == 1 && parseInt(item.Qty) <= 0"
                                size="large"
                                color="green"
                                :style="{marginRight: '25px', cursor: 'pointer'}"
                                icon="mdi:mdi-scissors-cutting"
                            ></v-icon>
                            <v-tooltip
                                v-if="item.IsCNCOpComplete == 1 && parseInt(item.Qty) <= 0"
                                activator="parent"
                                location="end"
                            >CNC COMPLETED
                            </v-tooltip>
                        </div>

                        <div class="grid-item" :class="getRowClassName(item)">
                            <v-text-field
                                v-if="!getError(item)"
                                v-model="requestedAmount[index]"
                                type="number"
                                min="0"
                                style="margin-top: 20px"
                                variant="outlined"
                                @input="
                                    handleInput(
                                        $event.target.value,
                                        index,
                                        item
                                    )
                                "
                            >
                                <template #append-inner>
                                    <v-btn
                                        size="x-small"
                                        variant="outlined"
                                        @click="sumTotalRequest(item, index)"
                                    >FULL
                                    </v-btn>
                                </template>
                            </v-text-field>
                            <v-card v-else variant="flat" class="errormsg">
                                <div class="errormsg-content">
                                    {{ getError(item) }}
                                </div>
                            </v-card>
                        </div>
                        <div class="grid-item" :class="getRowClassName(item)">
                            <v-btn
                                v-if="!showingAddByPart && material"
                                variant="elevated"
                                size="small"
                                color="primary"
                                @click="requestViewMaterial(PartNum)"
                                :disabled="comingFromLabor"
                            >
                                View Material
                            </v-btn>
                        </div>
                    </template>
                </div>
                <v-card-actions>
                    <v-col cols="6">
                        <v-btn
                            color="close"
                            variant="elevated"
                            block
                            @click="closeAllModals"
                            :disabled="comingFromLabor"
                        >(X) Close Dialog
                        </v-btn>
                    </v-col>

                    <v-col cols="6">
                        <v-btn
                            :disabled="enableNextStep"
                            color="primary"
                            variant="elevated"
                            block
                            @click="nextStep"
                        >Next
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-window-item>
            <v-window-item :value="2">
                <!---REQUESTED PART VIEW----->
                <v-dialog v-model="dialogViewMaterial" width="1700px">
                    <v-card class="overflow-y-auto">
                        <v-toolbar
                            color="primary"
                            :title="`Request Material Part: ${partNumberRequested}`"
                        >
                            <v-spacer></v-spacer>
                            <v-col cols="4">
                                <v-text-field
                                    v-model="searchValuePart"
                                    append-inner-icon="mid:mdi-magnify"
                                    label="Search"
                                    variant="solo"
                                    density="compact"
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-toolbar>
                        <v-card-text>
                            <EasyDataTable
                                :headers="headers_PartRequest"
                                :items="table_data_part_request"
                                v-model:items-selected="itemsSelectedPart"
                                :rows-per-page="25"
                                table-class-name="customize-table"
                                :search-value="searchValuePart"
                                :fixed-header="true"
                                :table-height="400"
                                header-text-direction="center"
                                border-cell
                                theme-color="#242939"
                            >
                                <template
                                    #item-Description="{
                                        Description,
                                        Qty,
                                        Available,
                                        Type,
                                    }"
                                >
                                    <div
                                        class="outerParent"
                                        v-if="Description.includes('OFFCUT')"
                                    >
                                        <div class="innerChild">
                                            <v-chip
                                                variant="elevated"
                                                color="pink"
                                                label
                                            >
                                                Offcut Material cannot be
                                                requested
                                            </v-chip>
                                        </div>
                                    </div>
                                    <!--
                            THE MATERIAL QUANTITY IS HIGHER THAN AVAILABLE ENTER HERE
                            AND Available == 0
                            --->
                                    <div class="outerParent" v-if="false">
                                        <!-- <div
                                        class="outerParent"
                                        v-if="Qty > Available && Available == 0"
                                    > -->
                                        <div v-if="Type == 'M'">
                                            <v-chip
                                                variant="elevated"
                                                color="pink"
                                                label
                                            >
                                                NOT PRODUCED FOR THIS JOB YET
                                            </v-chip>
                                        </div>
                                        <div v-else class="innerChild">
                                            <v-chip
                                                variant="elevated"
                                                color="pink"
                                                label
                                            >
                                                NOT AVAILABLE FOR THIS JOB
                                            </v-chip>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div class="outerParent">
                                            <div class="child">
                                                <v-text-field
                                                    variant="underlined"
                                                    type="number"
                                                    label="Request"
                                                >
                                                </v-text-field>
                                            </div>
                                            <div
                                                id="child"
                                                :style="{
                                                    marginLeft: '30px',
                                                    marginTop: '10px',
                                                }"
                                            >
                                                <v-btn color="grey">
                                                    Full
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </EasyDataTable>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-col cols="2">
                                <v-btn
                                    color="primary"
                                    variant="elevated"
                                    block
                                    @click="closeAllModals"
                                >(X) Close Dialog
                                </v-btn>
                            </v-col>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-window-item>
        </v-window>
        <div class="text-center">
            <v-dialog v-model="openModalRequestMaterial" width="auto">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-alert
                                dense
                                outlined
                                prominent
                                :model-value="alert"
                                shaped
                                type="success"
                            >Request Submitted Successfully!
                            </v-alert>
                            <v-col cols="12"
                            ><strong
                            >Part Number:
                                {{ editedItem[0].PartNum }}</strong
                            ></v-col
                            >
                            <v-col cols="12">
                                <strong
                                >Total Requested Qty:
                                    {{ totalRequestedAmount }}</strong
                                >
                            </v-col>
                            <v-col cols="12">
                                <strong
                                >Quantity in Warehouse:
                                    {{ editedItem[0].Available }}</strong
                                >
                            </v-col>

                            <v-col cols="12">
                                <v-select
                                    v-model="buildingFrom"
                                    label="Select Building"
                                    :items="buildingArray"
                                ></v-select>
                            </v-col>

                            <v-radio-group
                                v-model="radioColumn"
                                column
                                @update:modelValue="openVtextField"
                            >
                                <v-radio
                                    label="Assembly"
                                    value="Assembly"
                                ></v-radio>
                                <v-text-field
                                    v-if="openAssembly == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio label="CNC" value="CNC"></v-radio>
                                <v-text-field
                                    v-if="openCNC == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio
                                    label="Silkscreen"
                                    value="Silkscreen"
                                ></v-radio>
                                <v-text-field
                                    v-if="openSilkscreen == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio
                                    label="Vacuum Forming"
                                    value="Vacuum Forming"
                                ></v-radio>
                                <v-text-field
                                    v-if="openVacuumForm == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio
                                    label="New Stores"
                                    value="New Stores"
                                ></v-radio>
                                <v-text-field
                                    v-if="openNewStores == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio
                                    label="Handed Directly To"
                                    value="Handed Directly To"
                                ></v-radio>
                                <v-text-field
                                    v-if="openHandedTo == true"
                                    label="Specify Area"
                                    v-model="specify"
                                >
                                </v-text-field>
                                <v-radio
                                    label="Warehouse"
                                    value="Warehouse"
                                ></v-radio>
                                <v-select
                                    v-if="openWarehouse == true"
                                    :items="buildingArray"
                                    v-model="buildingGoingTo"
                                ></v-select>
                            </v-radio-group>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="commentText"
                                    bg-color="amber-lighten-4"
                                    rows="1"
                                    color="orange orange-darken-4"
                                    label="Comments for this part"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-row>
                            <v-col cols="12">
                                <v-btn
                                    :loading="loadingToApi"
                                    :disabled="disableSubmit ? true : false"
                                    color="primary"
                                    variant="elevated"
                                    block
                                    @click="submitRequest"
                                >Submit
                                    <template v-slot:loader>
                                        <v-progress-circular
                                            indeterminate
                                        ></v-progress-circular>
                                    </template>
                                </v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    color="grey"
                                    variant="elevated"
                                    block
                                    @click="closeModalRequestMaterial"
                                >Close
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    name: "AddPartTable",
    emits: ["closeMaterialUsed"],
    props: {
        material: {
            type: Object,
            default: null,
        },
        addByPartArr: {
            type: Object,
            default: null,
        },
        partNumber: {
            type: String,
            default: null,
        },
        comingFromLabor: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        openModalRequestMaterial(val) {
            val || this.closeModalRequestMaterial();
        },
        fullParts(newVal) {
            this.toggleDisabled = newVal.length === 0;
        },
    },
    computed: {
        fullName() {
            return `${this.$page.props.auth.user.firstName} ${this.$page.props.auth.user.lastName}`.trim();
        },
        toggleText() {
            if (this.fullParts.length === 0) {
                return "No Jobs Issued In Full";
            } else {
                return "Toggle Jobs Issued In Full";
            }
        },
        totalRequestedAmount() {
            return this.sumRequestedAmount(this.itemsSelectedMaterial);
        },
    },
    data: () => ({
        searchValue: "",
        requestedAmount: [],
        radioColumn: null,
        openModalRequestMaterial: false,
        loading: false,
        itemsSelectedPart: [],
        itemsSelectedMaterial: [],
        partNumberRequested: null,
        overlay: false,
        dialogViewMaterial: false,
        specify: "",
        editedItem: {},
        defaulteditedItem: {},
        commentText: "",
        searchValuePart: "",
        step: 1,
        table_data: [],
        partRequest: [],
        fullParts: [],
        notfullParts: [],
        checkBox: [],
        showingAll: false,
        toggleDisabled: false,
        showingAddByPart: false,
        headers: [
            {text: "Job #", value: "JobNum"},
            {text: "Part", value: "PartNum"},
            {
                text: "Asm",
                value: "AssemblySeq",
            },
            {
                text: "Mtl",
                value: "MtlSeq",
            },
            {
                text: "Required Qty",
                value: "RequiredQty",
            },
            {text: "Prev Issued", value: "IssuedQty"},
            {text: "Available", value: "Available"},
            {text: "On Hand", value: "Qty"},
            {text: "Request", value: "Description"},
        ],
        headers_PartRequest: [
            {text: "Part", value: "PartNum"},
            {text: "Asm", value: "AssemblySeq"},
            {text: "Mtl", value: "MtlSeq"},
            {text: "RequiredQty", value: "RequiredQty"},
            {text: "Prev Issued", value: "PrevOperation"},
            {text: "Available", value: "Available"},
            {text: "On Hand", value: "Qty"},
            {text: "Request", value: "Description"},
        ],
        table_data_part_request: [],
        loadingToApi: false,
        buildingArray: [],
        enableNextStep: true,
        openAssembly: false,
        openSilkscreen: false,
        openCNC: false,
        openVacuumForm: false,
        openNewStores: false,
        openWarehouse: false,
        openHandedTo: false,
        buildingFrom: null,
        buildingGoingTo: null,
        disableSubmit: false,
        alert: false,
        partErrorMessage: "",
    }),
    async created() {
    },
    async mounted() {
        await this.fetchBuildings();
        if (this.addByPartArr) {
            this.fullPartfilter(this.addByPartArr);
            this.showingAddByPart = true;
        } else {
            this.showingAddByPart = false;
            this.fetch();
        }
    },
    methods: {
        async fetch() {
            this.overlay = true;
            try {
                await axios
                    .get(
                        route("legacy-api.project-request-ope", {
                            jobNum: this.material.JobNum,
                            asmSeq: this.material.AsmSeq,
                            OpeSeq: this.material.OprSeq,
                        })
                    )
                    .then((res) => {
                        this.partRequest = res.data;
                    });
            } catch (err) {
                console.log(err);
                this.overlay = false;
            }
            this.overlay = false;
        },
        async fetchBuildings() {
            this.buildingArray = [];
            try {
                //NO NEED FOR EXT OR VENDORS. ONLY GET NUMBER BUILDINGS
                await axios
                    .get(
                        route("legacy-api.fetch-warehouse", {
                            fetchWarehouseOnly: 1,
                        })
                    )
                    .then((res) => {
                        this.sortDropdown(res.data);
                    });
            } catch (err) {
                console.log(err);
            }
            this.loading = false;
        },
        async submitRequest() {
            this.loadingToApi = true;

            if (this.buildingFrom == this.buildingGoingTo) {
                this.loadingToApi = false;
                alert("Can Not Pick Same Building");

                return;
            }
            let formData = new FormData();

            for (var i = 0; i < this.itemsSelectedMaterial.length; i++) {
                let JobNum = this.itemsSelectedMaterial[i].JobNum;
                let PartNum = this.itemsSelectedMaterial[i].PartNum;
                let MtlSeq = this.itemsSelectedMaterial[i].MtlSeq;
                let AssemblySeq = this.itemsSelectedMaterial[i].AssemblySeq;
                let RequiredQty = this.itemsSelectedMaterial[i].RequiredQty;

                let IssuedQty = this.itemsSelectedMaterial[i].IssuedQty;
                let Available = this.itemsSelectedMaterial[i].Available;
                let Qty = this.itemsSelectedMaterial[i].Qty;
                let FullIssue = this.itemsSelectedMaterial[i].FullIssue;
                let Type = this.itemsSelectedMaterial[i].Type;
                let PartClass = this.itemsSelectedMaterial[i].PartClass;
                let Group = this.itemsSelectedMaterial[i].Group;
                let Table = this.itemsSelectedMaterial[i].Table;
                let Description = this.itemsSelectedMaterial[i].Description;
                let PrevOperation = this.itemsSelectedMaterial[i].PrevOperation;
                let Staged = this.itemsSelectedMaterial[i].Staged;
                let OnList = this.itemsSelectedMaterial[i].OnList;

                let SysRowID = this.itemsSelectedMaterial[i].SysRowID;
                let ReqAmt = this.itemsSelectedMaterial[i].RequestedAmount;

                formData.append("Requests[" + i + "][JobNum]", JobNum);
                formData.append("Requests[" + i + "][PartNum]", PartNum);
                formData.append(
                    "Requests[" + i + "][OprSeq]",
                    this.material.OprSeq
                );
                formData.append(
                    "Requests[" + i + "][AssemblySeq]",
                    AssemblySeq
                );
                formData.append("Requests[" + i + "][MtlSeq]", MtlSeq);

                formData.append(
                    "Requests[" + i + "][RequiredQty]",
                    RequiredQty
                );
                formData.append("Requests[" + i + "][IssuedQty]", IssuedQty);
                formData.append("Requests[" + i + "][Available]", Available);
                formData.append("Requests[" + i + "][Qty]", Qty);
                formData.append("Requests[" + i + "][FullIssue]", FullIssue);
                formData.append("Requests[" + i + "][Type]", Type);
                formData.append("Requests[" + i + "][PartClass]", PartClass);
                formData.append("Requests[" + i + "][Group]", Group);
                formData.append("Requests[" + i + "][SysRowID]", SysRowID);
                formData.append("Requests[" + i + "][Table]", Table);

                formData.append(
                    "Requests[" + i + "][Description]",
                    Description
                );
                formData.append(
                    "Requests[" + i + "][PrevOperation]",
                    PrevOperation
                );
                formData.append("Requests[" + i + "][Staged]", Staged);
                formData.append("Requests[" + i + "][OnList]", OnList);
                formData.append("Requests[" + i + "][RequestQuantity]", ReqAmt);
                if (this.itemsSelectedMaterial[i].PrevOprSeq) {
                    let PrevOprSeq = this.itemsSelectedMaterial[i].PrevOprSeq;
                    formData.append(
                        "Requests[" + i + "][PrevOprSeq]",
                        PrevOprSeq
                    );
                }
            }
            formData.append("Building", this.buildingFrom);
            //if they select a ware house to go on the radio buttons
            if (this.radioColumn == "Warehouse") {
                formData.append("Building", this.buildingGoingTo);
            } else if (this.radioColumn == "Handed Directly To") {
                let string = this.radioColumn + " " + this.fullName;
                formData.append("Area", string);
            } else {
                formData.append("Area", this.radioColumn);
            }

            formData.append("Comment", this.commentText);
            try {
                await axios
                    .post(
                        route("legacy-api.project-add-part-request"),
                        formData
                    )
                    .then((res) => {
                        if (res.data.Status == 0) {
                            this.partErrorMessage = res.data.Message;
                        } else {
                            setTimeout(() => {
                                this.alert = true;
                            }, 1000);
                            setTimeout(() => {
                                this.enableNextStep = true;
                                this.fetch();
                                this.refresh();
                                this.closeAllModals();
                            }, 3000);
                        }
                    });
            } catch (err) {
                console.log(err);
                this.errors = err.response.data.errors;
                this.loadingApi = false;
            }
            this.loadingToApi = false;
            this.disableSubmit = true;
        },
        sumTotalRequest(item, index) {
            const sum = Number(item.RequiredQty) - Number(item.IssuedQty);
            const available = Number(item.Available);
            const total = sum <= available ? sum : available;
            this.requestedAmount[index] = total;
            this.checkBox[index] = true;
            this.handleInput(total, index, item);
        },
        disableNextbutton() {
            if (this.itemsSelectedMaterial.length) {
                for (let i = 0; i < this.itemsSelectedMaterial.length; i++) {
                    if (
                        this.itemsSelectedMaterial[i].Description.includes(
                            "OFFCUT"
                        )
                    ) {
                        alert(
                            "You have selected an OFFCUT. You can not make a request on"
                        );
                        return;
                    }
                    // else if (
                    //     this.itemsSelectedMaterial[i].Available <= 0 ||
                    //     this.itemsSelectedMaterial[i].Qty <= 0
                    // ) {
                    //     alert("Awaiting Approval");
                    //     return;
                    // }
                }
                this.enableNextStep = false;
            }
        },
        closeModalRequestMaterial() {
            this.openModalRequestMaterial = false;
        },
        nextStep() {
            this.editedItem = Object.assign({}, this.itemsSelectedMaterial);
            this.openModalRequestMaterial = true;
        },
        refresh() {
            this.$emit("refresh");
        },
        closeMaterialUsed() {
            this.$emit("closeMaterialUsed");
        },
        closeAllModals() {
            this.dialogViewMaterial = false;
            this.openModalRequestMaterial = false;
            this.$emit("closeMaterialUsed");
        },
        onClearClicked() {
            this.searchValue = "";
        },
        async requestViewMaterial(PartNum) {
            /*STEP CONTROL THE MODAL
            WHEN THE USER CLICKS IT WILL GO TO THE 2 WINDOW
            FOLLOWING THE CORRECT STEP
            * */
            this.step++;
            this.overlay = true;
            this.partNumberRequested = PartNum;
            try {
                await axios
                    .get(
                        route("legacy-api.project-part-request", {
                            part: PartNum,
                        })
                    )
                    .then((res) => {
                        this.table_data_part_request = res.data;
                        this.dialogViewMaterial = true;
                    });
            } catch (err) {
                console.log(err);
            }
            this.overlay = false;
        },
        sortDropdown(array) {
            //SORTS BUILDING DROPDOWN TO BE IN NUMERICAL ORDER
            this.buildingArray = [];
            array.sort(function (a, b) {
                var nameA = parseInt(a);
                var nameB = parseInt(b);
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            this.buildingArray = array;
        },
        openVtextField(item) {
            this.specify = "";
            if (item == "Assembly") {
                this.openAssembly = true;

                this.openSilkscreen = false;
                this.openCNC = false;
                this.openVacuumForm = false;
                this.openNewStores = false;

                this.openHandedTo = false;
                this.openWarehouse = false;
            } else if (item == "Silkscreen") {
                this.openSilkscreen = true;
                this.openAssembly = false;
                this.openCNC = false;
                this.openVacuumForm = false;
                this.openNewStores = false;
                this.openNewStores = false;
                this.openHandedTo = false;
                this.openWarehouse = false;
            } else if (item == "CNC") {
                this.openCNC = true;
                this.openAssembly = false;
                this.openSilkscreen = false;

                this.openVacuumForm = false;
                this.openNewStores = false;
                this.openNewStores = false;
                this.openHandedTo = false;
                this.openWarehouse = false;
            } else if (item == "Vacuum Forming") {
                this.openVacuumForm = true;

                this.openCNC = false;
                this.openAssembly = false;
                this.openSilkscreen = false;
                this.openNewStores = false;
                this.openHandedTo = false;
                this.openWarehouse = false;
            } else if (item == "New Stores") {
                this.openNewStores = true;

                this.openCNC = false;
                this.openAssembly = false;
                this.openSilkscreen = false;
                this.openVacuumForm = false;

                this.openHandedTo = false;
                this.openWarehouse = false;
            } else if (item == "Warehouse") {
                this.openWarehouse = true;

                this.openNewStores = false;
                this.openCNC = false;
                this.openAssembly = false;
                this.openCNC = false;
                this.openVacuumForm = false;
                this.openHandedTo = false;
                this.openSilkscreen = false;
            } else if (item == "Handed Directly To") {
                this.openHandedTo = true;
                this.specify = this.fullName;
                this.openNewStores = false;
                this.openSilkscreen = false;
                this.openCNC = false;
                this.openAssembly = false;
                this.openCNC = false;
                this.openVacuumForm = false;
                this.openWarehouse = false;
            }
        },
        getRowClassName(item) {
            let className = "";

            switch (item.Type) {
                case "A":
                    className = "type-A";
                    break;
                case "M":
                    className = "type-M";
                    break;
                case "SM":
                    className = "type-SM";
                    break;
                case "OM":
                case "OA":
                    className = "type-OM-OA";
                    break;
                case "SA":
                    className = "type-SA";
                    break;
                case "PO":
                    className = "type-PO";
                    break;
            }

            if (item.FullIssue) {
                className += "-dull";
            }

            return className;
        },
        getPartClass(item) {
            const desc = item.Description;
            let type = "";

            if (item.PartClass === "M") {
                type = "(Manufactured Part)";
            } else {
                type = "(Purchased Part)";
            }

            return `${desc} ${type}`;
        },
        getError(item) {
            const onList = parseInt(item.OnList);

            if (onList === 0) {
                if (item.Description.includes("OFFCUT")) {
                    return "OFFCUT Material Cannot Be Requested";
                } else {
                    return false;
                }
            } else {
                if (onList > 0) {
                    return "Material Is Currently On Request List";
                } else if (item.Description.includes("OFFCUT")) {
                    return "OFFCUT Material Cannot Be Requested";
                }
            }
        },
        fullPartfilter(arr) {
            (this.fullParts = []),
                (this.notfullParts = []),
                arr.forEach((item) => {
                    const requiredQty = parseInt(item.RequiredQty);
                    const issuedQty = parseInt(item.IssuedQty);
                    if (item.FullIssue == true || requiredQty <= issuedQty) {
                        this.fullParts.push(item);
                    } else {
                        this.notfullParts.push(item);
                    }
                });
            this.partRequest = this.notfullParts;
        },
        toggleFull() {
            this.showingAll = !this.showingAll;
            if (!this.showingAll) {
                this.partRequest = this.addByPartArr;
            } else {
                this.partRequest = this.notfullParts;
            }
        },
        isSelected(item) {
            return this.itemsSelectedMaterial.includes(item);
        },
        handleInput(value, index, item) {
            this.updateSelectedMaterial(value, index, item);
            this.disableNextbutton();
        },
        toggleSelectedMaterial(item, index) {
            const selectedIndex = this.itemsSelectedMaterial.findIndex(
                (selectedItem) => selectedItem.SysRowID === item.SysRowID
            );
            if (selectedIndex === -1) {
                this.itemsSelectedMaterial.push(item);
            } else {
                this.itemsSelectedMaterial.splice(index, 1);
                this.requestedAmount[index] = null;
            }
        },
        updateSelectedMaterial(value, index, item) {
            const quantity = parseInt(value);
            const diff = parseInt(item.RequiredQty) - parseInt(item.IssuedQty);

            if (quantity > 0) {
                if (!this.isSelected(item)) {
                    if (quantity <= parseInt(item.Available)) {
                        if (quantity <= parseInt(diff)) {
                            item.RequestedAmount = parseInt(
                                this.requestedAmount[index]
                            );
                            this.itemsSelectedMaterial.push(item);
                            this.checkBox[index] = true;
                        } else {
                            alert(
                                "Quantity requested is more than the required quantity and tolerance quantity"
                            );
                            this.requestedAmount[index] = null;
                            this.checkBox[index] = false;
                        }
                    } else {
                        alert("Not Enough Quantity Available for Request");
                        this.requestedAmount[index] = null;
                        this.checkBox[index] = false;
                    }
                } else {
                    const selectedItem = this.itemsSelectedMaterial.find(
                        (selectedItem) =>
                            selectedItem.SysRowID === item.SysRowID
                    );
                    if (selectedItem) {
                        if (quantity <= parseInt(item.Available)) {
                            if (quantity <= parseInt(diff)) {
                                selectedItem.RequestedAmount = Number(
                                    this.requestedAmount[index]
                                );
                                this.checkBox[index] = true;
                            } else {
                                alert(
                                    "Quantity requested is more than the required quantity and tolerance quantity"
                                );
                                this.requestedAmount[index] = null;
                                this.checkBox[index] = false;
                            }
                        } else {
                            alert("Not Enough Quantity Available for Request");
                            this.requestedAmount[index] = null;
                            this.checkBox[index] = false;
                        }
                    }
                }
            } else {
                const selectedIndex = this.itemsSelectedMaterial.findIndex(
                    (selectedItem) => selectedItem.SysRowID === item.SysRowID
                );
                if (selectedIndex > -1) {
                    this.itemsSelectedMaterial.splice(selectedIndex, 1);
                    this.checkBox[index] = false;
                }
            }
        },

        sumRequestedAmount(itemsSelected) {
            return itemsSelected.reduce(
                (total, item) => total + item.RequestedAmount,
                0
            );
        },
    },
};
</script>
<style lang="css" scoped>
.outerParent {
    display: flex;
    justify-content: center;
}

.container {
    color: #3869d4;
}

#contain {
    display: flex;
    width: 100%;
}

.containerNotes {
    display: flex;
    cursor: pointer;
}

.containerFlex {
    display: flex;
    cursor: pointer;
}

.customize-table {
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 63px;
    --easy-table-body-row-font-size: 15px;

    --easy-table-footer-background-color: #ffffff;
    --easy-table-footer-font-color: #242939;
    --easy-table-footer-font-size: 15px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 55px;

    --easy-table-rows-per-page-selector-width: 75px;
    --easy-table-rows-per-page-selector-option-padding: 15px;

    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-loading-mask-background-color: #ffffff;
}

:deep(.type-A) {
    background-color: lightblue;
}

:deep(.type-M) {
    background-color: #f5ed90;
}

:deep(.type-SM) {
    background-color: lightgreen;
}

:deep(.type-OM-OA) {
    background-color: lavender;
}

:deep(.type-SA) {
    background-color: lightgreen;
}

:deep(.type-PO) {
    background-color: #2196f3;
}

:deep(.type-A-dull) {
    background-color: rgba(173, 216, 230, 0.5);
}

:deep(.type-M-dull) {
    background-color: rgba(245, 237, 144, 0.5);
}

:deep(.type-SM-dull) {
    background-color: rgba(144, 238, 144, 0.5);
}

:deep(.type-OM-OA-dull) {
    background-color: rgba(230, 230, 250, 0.5);
}

:deep(.type-SA-dull) {
    background-color: rgba(144, 238, 144, 0.5);
}

:deep(.type-PO-dull) {
    background-color: rgba(33, 150, 243, 0.5);
}

.grid {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto;
    padding: 5px;
    margin-bottom: 10px;
}

.grid-item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.grid-header {
    text-align: center;
    margin-bottom: 10px;
    border-bottom: 1px solid lightgray;
}

.errormsg {
    color: red;
    font-size: 13px;
    line-height: 1.2;
    font-weight: bold;
    background-color: #ffd1d1;
    border: solid thin red;
    white-space: normal;
    width: 100%;
    height: 85%;
    margin-top: 20px;
    margin-bottom: 20px;
}

.errormsg-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
